// extracted by mini-css-extract-plugin
export default {"logoFsfbHeader":"MainHeaderLogo_logoFsfbHeader__ZkwXi"};